<div class="tag" [matTooltip]="tag.name"
     style="height: 15px; width: 15px; border-radius: 50%;"
     [style.background-color]="tag.color" *ngIf="!!tag"
     [style.box-shadow]="addBoxShaddow ? ' 5px 5px 5px 5px red' : undefined">
</div>
